export const CREATE_AI_ARTIFACT_NAME = "create_ai_artifact";
export const READ_AI_ARTIFACT_NAME = "read_ai_artifact";
export const UPDATE_AI_ARTIFACT_NAME = "update_ai_artifact";

export const AI_ARTIFACT_TOOL_NAMES = [
  CREATE_AI_ARTIFACT_NAME,
  READ_AI_ARTIFACT_NAME,
  UPDATE_AI_ARTIFACT_NAME,
] as const;

export const CREATE_AI_ARTIFACT_DESC = `Creates a private static HTML/CSS artifact.

Use this when the user asks to save, create, or persist a report or artifact. Do not ask the user to click Save as artifact.

Input:
- title (required): Short artifact title, max 200 characters.
- html (required): Full HTML document or body content. Use tables, headings, and semantic markup for data.
- css (optional): Inline styles for layout, typography, and responsive presentation.

Static artifacts do not support JavaScript, JSON data scripts, external assets, forms, or nested frames. Use HTML tables and CSS for charts and layout.

Returns:
- id, organizationId, title, revision, shared, and sourceChatID from the successful save response.

After success, respond briefly. Do not paste the full bundle again.`;

export const READ_AI_ARTIFACT_DESC = `Reads the current authorized static HTML/CSS content and revision of an existing artifact.

Call this before update_ai_artifact so you edit against the latest revision.

Input:
- id (required): Artifact ID from a prior create_ai_artifact or update_ai_artifact result.

Returns:
- id, organizationId, title, revision, shared, html, and css.`;

export const UPDATE_AI_ARTIFACT_DESC = `Updates an existing artifact while preserving its visibility (private/shared).

Always call read_ai_artifact first, then pass the returned revision as expectedRevision. Stale revisions are rejected; do not invent a new artifact on conflict.

Input:
- id (required): Artifact ID to update.
- expectedRevision (required): Revision from read_ai_artifact or the latest successful save.
- title (optional): New title; omit to keep the current title.
- html, css (required): Full replacement static bundle fields.

Returns:
- id, organizationId, title, revision, shared, and sourceChatID from the successful save response.

After success, respond briefly.`;
